<template>
  <div class="m-login-callback">
    <AtomLoadingPrimary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeLoginCallback'
}
</script>
